import React from "react";
import { withStyles } from "material-ui/styles";
import Radio from "material-ui/Radio";
import { Button } from "material-ui";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";
import ErrorMessage from "components/ErrorMessage";

const styles = theme => {
  return {
    dialogContent: {
      width: 800
    },
    errorMessage: {
      fontSize: ".9rem",
      marginBottom: 10
    },
    paperDesc: {
      color: "#9699a2",
      fontSize: "1rem",
      fontWeight: 300,
      marginBottom: 5
    },
    paperValue: {
      color: "#575962",
      marginTop: "0.5rem",
      marginLeft: "1rem",
      display: "inline-block",
      fontSize: "1.1rem",
      fontWeight: 600
    },
    container: {
      display: "flex",
      flexWrap: "wrap"
    },
    formControl: {
      margin: theme.spacing.unit,
      minWidth: 120
    },
    surveyItem: {
      border: "1px dashed gray",
      marginBottom: 10
    },
    checked: {
      color: "rgb(38, 166, 154)"
    }
  };
};

class SelectSurveyModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: ""
    };
  }
  handleChange(event) {
    this.setState({ selectedValue: event.target.value });
  }
  createListItem(survey) {
    return (
      <div
        id={survey.id}
        key={survey.id}
        tabIndex={survey.id}
        className={this.props.classes.surveyItem}
      >
        <Radio
          checked={this.state.selectedValue === String(survey.id)}
          color="primary"
          onChange={e => this.handleChange(e)}
          value={String(survey.id)}
          classes={{
            checked: this.props.classes.checked
          }}
        />
        <div
          style={{
            display: "inline-block",
            marginLeft: 20,
            width: 200,
            verticalAlign: "middle"
          }}
        >
          {survey.surveyName}
        </div>
        <div
          style={{
            display: "inline-block",
            marginLeft: 20,
            verticalAlign: "middle"
          }}
        >
          {survey.termFmt()}
        </div>
      </div>
    );
  }
  render() {
    const { classes, selectSurveyModal } = this.props;
    const { open, surveyList, errors } = selectSurveyModal;
    return (
      <Dialog open={open}>
        <DialogTitle id="form-dialog-title">
          過去のアンケートの設定を利用
        </DialogTitle>

        <DialogContent className={classes.dialogContent}>
          <ErrorMessage messages={errors} className={classes.errorMessage} />
          <div>
            <div className={classes.paperDesc}>アンケート一覧</div>
          </div>
          <div
            style={{
              padding: 10,
              border: "1px solid darkgrey",
              overflowY: "scroll",
              height: 270
            }}
          >
            {surveyList.map(survey => this.createListItem(survey))}
          </div>
        </DialogContent>
        <DialogActions>
          <Button raised onClick={this.props.handleClose}>
            キャンセル
          </Button>
          <Button
            raised
            onClick={() =>
              this.props.applySurveyDetail(this.state.selectedValue)
            }
          >
            設定を反映
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(SelectSurveyModal);



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/BaseInfo/SelectSurveyModal.jsx